import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Select from 'react-select';
import _sortBy from 'lodash/sortBy';

import withEhsPageBehavior from '../../withEhsPageBehavior';
import { history } from '../../state/store';

import Button from '../form/Button';
import Message from '../form/Message';

import Subnav from '../subnav';
import OrganizationApi from '../../api/organization';
import TemplateApi from '../../api/template';

class NewOrganizationPage extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            errorMessage: null,
            isbusy: false,
            abbreviation: '',
            name: '',
            start_date: moment(),
            end_date: moment().add('9', 'months'),
            use_nys: false,
            selectedTemplate: null,
            allAvailableTemplates: [],
        };

        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    async componentDidMount() {
        // We need to force the latest version of the initial templates.
        // Get the newest templates.
        const initialTemplates = await TemplateApi.getLatestInitialTemplates();

        this.setState({
            allAvailableTemplates: this.getSelectOptions(initialTemplates),
        });
    }

    onFormSubmit(evt) {
        evt.preventDefault();
        this.setState({ errorMessage: null, isbusy: true }, () => {
            // create new organization
            const {
                name,
                abbreviation,
                start_date,
                end_date,
                selectedTemplate,
                use_nys,
            } = this.state;

            // Ensure a template is selected.
            if (!selectedTemplate) {
                this.setState({
                    isbusy: false,
                    errorMessage:
                        'Please select a recognition for this organization.',
                });
                return;
            }

            const attrs = {
                name,
                abbreviation,
                start_date,
                end_date,
                template: selectedTemplate,
                use_nys,
            };

            OrganizationApi.create(attrs)
                .then(org => {
                    this.setState({ isbusy: false });
                    // go back to the manage organizations page
                    history.push('/consultant/organizations');
                })
                .catch(errorMessage => {
                    this.setState({ isbusy: false, errorMessage });
                });
        });
    }

    onSelectChange = selectedTemplate => {
        if (selectedTemplate) {
            const { variant } = selectedTemplate;
            // Check if this is a NYS template.
            if (variant && variant === 'NYS') {
                this.setState({ selectedTemplate, use_nys: true });
            } else {
                this.setState({ selectedTemplate, use_nys: false });
            }
        } else {
            // Set the selected template to null.
            this.setState({ selectedTemplate, use_nys: false });
        }
    };

    getSelectOptions = templates => {
        // Add a label to the template object for the select menu.
        const yearsArray = templates.map(template => {
            const { type } = template;
            const variant = template.variant || '';
            const version = template.version || '';

            const label = `${variant} ${type} ${version}`;
            // Remove white space.
            const trimmed = label.trim();
            return { label: trimmed, ...template };
        });

        return _sortBy(yearsArray, 'label');
    };

    render() {
        const { selectedTemplate, allAvailableTemplates } = this.state;
        return (
            <div className="page">
                <div className="page__subnav">
                    <Subnav />
                </div>
                <div className="page__body">
                    <h2>Add a new organization</h2>
                    <p className="lead">
                        Add an organization to your consultancy account by
                        filling in the information below.
                    </p>
                    <form onSubmit={this.onFormSubmit}>
                        <div className="form__field">
                            <label htmlFor="name">Organization Name</label>
                            <input
                                type="text"
                                required
                                name="name"
                                value={this.state.name}
                                onChange={evt => {
                                    this.setState({ name: evt.target.value });
                                }}
                            />
                        </div>

                        <div>
                            <div className="form__field">
                                <label htmlFor="select-templates-initial">
                                    Select A Recognition
                                </label>
                                <Select
                                    id="select-templates-initial"
                                    options={allAvailableTemplates}
                                    value={selectedTemplate}
                                    onChange={this.onSelectChange}
                                />
                            </div>
                            {/* <div className="form__checkbox">
                                <input
                                    id="useNYSRequiredCriteriaInitial"
                                    name="useNYSRequiredCriteria"
                                    type="checkbox"
                                    checked={this.state.use_nys}
                                    onChange={() => {
                                        this.setState({
                                            use_nys: !this.state.use_nys,
                                        });
                                    }}
                                />
                                <label htmlFor="useNYSRequiredCriteriaInitial">
                                    NYS Required Criteria
                                </label>
                            </div>
                            {this.state.use_nys && (
                                <p>
                                    Once Practices are added this selection is
                                    not editable.
                                </p>
                            )} */}
                        </div>

                        <div className="form__field">
                            <label htmlFor="abbreviation">Abbreviation</label>
                            <input
                                type="text"
                                name="abbreviation"
                                value={this.state.abbreviation}
                                onChange={evt => {
                                    this.setState({
                                        abbreviation: evt.target.value,
                                    });
                                }}
                            />
                        </div>

                        <div className="form__buttons">
                            <Button
                                type="submit"
                                defaultText="Save"
                                busyText="Saving"
                                isbusy={this.state.isbusy}
                            />
                            <Link to="/consultant/organizations">Cancel</Link>
                        </div>

                        <div className="form__footer">
                            <Message error={this.state.errorMessage} />
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default withEhsPageBehavior(NewOrganizationPage);
